import BioFacilitators from "@/views/configs/biomicroscopy/index.vue";

export default [
  {
    path: "bio",
    name: "Configurações Biomicroscopia",
    component: BioFacilitators,
  },
];
